import React from 'react';
import { ShowIf } from 'components/utils';
import { DropDownMulipleUse } from 'components/tt-forms';

class InputListDropDown extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      data: [],
      value: '',
      outputItem: '',
      indexConfirm: ''
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.data != this.props.data) {
      this.convertValueToData(nextProps.data)
    }
  }

  componentDidMount() {
    this.convertValueToData(this.props.data);
    this.props.onRef(this);
  }

  componentWillUnmount() {
    this.props.onRef(undefined);
  }

  handleConfirm(data) {
    if(this.props.handleConfirm(data)) {
      //do nothing
    } else {
      this.removeDonViConfirm();
    }
  }

  convertValueToData(data) {
    let dataResult = [];
    let newCheck = data;
    if (newCheck) {
      newCheck.map(state => {
        dataResult[dataResult.length] = {
          ten: state[this.props.valueName],
          giaTri: state[this.props.keyName]
        }
      })
      this.setState({
        data: [...dataResult]
      })
    } else {
      this.setState({
        data: []
      })
    }
  }

  convertDataToValue() {
    let e = {
      target: {
        value: [],
        count: this.state.data.length
      }
    }
    this.state.data.map((state, i) => {
      e.target.value[e.target.value.length] = {
        id: Number(state.giaTri)
      }
    })
    this.props.onChange(e);
  }

  onChange(e) {
    let index = e.nativeEvent.target.selectedIndex;

    let newArr = [...this.state.data];

    let arrCheck = newArr.filter(state => {
      return state.giaTri == e.target.value
    })

    if (arrCheck.length > 0) {
      this.setState({
        value: ''
      })
    } else {
      let newItem = {
        giaTri: e.target.value,
        ten: e.nativeEvent.target[index].text
      }
      this.setState({
        data: [
          ...this.state.data,
          newItem
        ],
        value: '',
        outputItem: e.target.value
      }, () => {
        this.convertDataToValue();
        this.props.onAddItem(this.state.outputItem);
      })
    }
  }

  removeDonVi(index) {
    if(this.props.confirm) {
      this.setState({
        indexConfirm: index
      }, () => {
        this.handleConfirm(this.state.data[index]);
      })
    } else {
      let newData = [...this.state.data];
      let itemDelete = this.state.data[index];
      this.props.onRemoveItem(itemDelete.giaTri);
      newData.splice(index, 1);
      this.setState({
        data: newData
      }, () => {
        this.convertDataToValue()
      })
    }
  }

  removeDonViConfirm() {
    let newData = [...this.state.data];
    newData.splice(this.state.indexConfirm, 1);
    this.setState({
      data: newData
    }, () => {
      this.convertDataToValue()
    })
  }

  render() {
    return (
      <form className='wrap-tt-dvph col-100 no-gutter'>
        <div className='wrap-input-tt-dvph col-25'>
          <DropDownMulipleUse label={this.props.label} data={this.props.dataOption} keyName={this.props.keyName} valueName={this.props.valueName} className='col-100 no-gutter'selectedValue={this.state.value} onChange={this.onChange.bind(this)}/>
        </div>
        <ShowIf condition={!this.props.hasCount}>
          <div className='col-75 mb18'>
            <div className='ds-tt-dvph'>
              {
                this.state.data.map((item,i) => {
                  return (
                    <div className='tt-dvph-item' key={i}>
                      <span className="tt-dvph-icon" onClick={this.removeDonVi.bind(this,i)}>×</span>
                      <span className="tt-dvph-value">{item.ten}</span>
                    </div>
                  )
                })
              }
            </div>
          </div>
        </ShowIf>
        <ShowIf condition={this.props.hasCount}>
          <div className='col-60 mb18'>
            <div className='ds-tt-dvph'>
              {
                this.state.data.map((item,i) => {
                  return (
                    <div className='tt-dvph-item' key={i}>
                      <span className="tt-dvph-icon" onClick={this.removeDonVi.bind(this,i)}>×</span>
                      <span className="tt-dvph-value">{item.ten}</span>
                    </div>
                  )
                })
              }
            </div>
          </div>
          <div className='col-15 mb18 count-dv'>
            Tổng: {this.state.data.length}&nbsp;{this.props.countUnit}
          </div>
        </ShowIf>
      </form>
    );
  }
}

InputListDropDown.defaultProps = {
  data: '',
  label: 'This is label',
  hasCount: false,
  confirm: false,
  onRef: function() {
  },
  countUnit: 'đơn vị',
  onAddItem: function() {},
  onRemoveItem: function() {},
  onChange: function() {
    console.log('Need to assign onChange method');
  }
}

export default InputListDropDown;


// WEBPACK FOOTER //
// ./src/components/tt-forms/common/InputListDropDown.jsx